import {
  FreeLink as LibFreeLink,
  pickFreeLinkSettings
} from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../constants';
import { isInlineLayout } from '../../utils';
import { useFreeLinkStyles } from './utils';

const { appAlias, appName } = meta;

export function FreeLink() {
  const { layout, ...settings } = useSettings();
  const { freeLinkAnchor: _, ...freeLinkSettings } =
    pickFreeLinkSettings(settings);
  const freeLinkStyles = useFreeLinkStyles();
  const freeLinkMode = isInlineLayout(layout) ? 'button' : 'text';

  return (
    <LibFreeLink
      {...freeLinkSettings}
      style={freeLinkStyles}
      mode={freeLinkMode}
      appAlias={appAlias}
      appName={appName}
    />
  );
}
